import React, { useEffect, useRef } from 'react';

const WidgetPreview = ({ identifier, templateIdentifier, previewKey }) => {
  const containerReference = useRef(null);

  useEffect(() => {
    if (!identifier) {
      return;
    }

    // Reset the global init flag to allow re-initialization
    window.DieCutTemplatesQuoteBuilderInit = false;

    // Clear any existing content in the container
    const container = containerReference.current;
    if (container) {
      const widgetDiv = container.querySelector('.diecuttemplates_widget');
      if (widgetDiv) {
        widgetDiv.innerHTML = '';
      }
    }

    // Remove any existing widget script
    const existingScript = document.querySelector('script[data-widget-preview="true"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Load the widget script
    const script = document.createElement('script');
    script.src = `/js/quote_builder/${identifier}.js`;
    script.async = true;
    script.setAttribute('data-widget-preview', 'true');
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      window.DieCutTemplatesQuoteBuilderInit = false;
      const scriptToRemove = document.querySelector('script[data-widget-preview="true"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [identifier, previewKey]);

  if (!identifier) {
    return null;
  }

  return (
    <div ref={containerReference}>
      <div
        className="diecuttemplates_widget"
        data-id={templateIdentifier}
      />
    </div>
  );
};

export default WidgetPreview;
